module.exports = __webpack_public_path__ + "img/Studio B.ad4ad69b.jpg";